import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import HybridHeaderBar from '../../shared/HybridHeaderBar/hybrid.header.bar.vue';
import HybridTabs from '../../shared/HybridTabs/hybrid.tabs.vue';
import HybirdCouponCard from '../../shared/HybridCouponCard/hybrid.coupon.card.vue';
import { Coupon } from '../../shared/HybridCouponCard/hybrid.coupon.card.component';
import { CouponMyCouponsDelegate } from '../../services/DataDelegate/CouponDelegate/coupon.my.coupons.delegate';
import { CommonConfig } from '../../../configs/config.common';
import { findComponentsDownward } from '../../../utils/assist';
import { UserInfoDelegate } from '../../services/DataDelegate/UserDelegate/user.info.delegate';
import * as moment from 'moment';
import CouponStatus from '../../mixins/coupon.status.mixin';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { getCondition } from '../../../utils/price.condition';
import { I18N } from '../../../utils/i18n/i18n';

@Component(
    {
        components: {
            'layout': HybridBasicLayout,
            HybridHeaderBar,
            HybridTabs,
            HybirdCouponCard
        },
        mixins: [CouponStatus]
    }
)
export default class HybridCouponMycoupons extends Vue {
    public configs = new CommonConfig();
    public selectTab = 'valid';
    public couponList: Coupon[] = [];
    public myCouponsDelegate = new CouponMyCouponsDelegate();
    public userInfoDelegate = new UserInfoDelegate();
    public userInfo: any = null;
    public data: Coupon[] = [];

    public async created() {
        CallNative.setNativeNavTitle('我的优惠券', 'My Coupons');
    }
    public async getMyCoupons(respartnerId: number) {
        const fetched = await this.myCouponsDelegate.getList(respartnerId);
        if (fetched && fetched.data && fetched.data.list) {
            const configs = this.configs;
            const self = this;
            this.data = fetched.data.list.map(function (v: any) {
                const placeHolder = configs.housePicPlaceHolder;
                const coverImgaes = v.xcoverimages ? JSON.parse(v.xcoverimages) : [];
                const condition = getCondition(
                    v.xcategory,
                    v.xdiscountpercent,
                    v.xdiscountamount,
                    v.xrequestedamount,
                    self.$i18n.locale);
                const title = (self.$i18n.locale === I18N.EI18nLocale.Zn)
                    ? v.couponnamecn
                    : (self.$i18n.locale === I18N.EI18nLocale.En) ? v.couponnameen : self.$t('18');

                const slogan = (self.$i18n.locale === I18N.EI18nLocale.En) ? v.coupontagline : self.$t('19');
                const newCoupon: Coupon = {
                    id: v.couponid,
                    title: title,
                    img: coverImgaes && coverImgaes.length ? coverImgaes[0] : placeHolder,
                    slogan: slogan,
                    expirationDate: v.couponexpireddate ? moment(v.couponexpireddate).format(configs.dateFormat) : '',
                    price: v.xprice ? v.xprice : 0,
                    condition: condition,
                    status: v.insstatus,
                    insId: v.insid
                };
                return newCoupon;
            });
            this.updateCouponList();
        }
    }
    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(globalPudge: any, globalPudgeOld: any) {
        const fjjUserId = globalPudge.getParam('fjjUserId');
        if (fjjUserId) {
            await this.getUserInfo(fjjUserId);
            if (this.userInfo) {
                const respartnerId = this.userInfo.resPartnerId;
                if (respartnerId && !isNaN(respartnerId)) {
                    await this.getMyCoupons(parseInt(respartnerId, 10));
                }
            }

        }
    }
    public updateCouponList() {
        if (this.selectTab === 'invalid') {
            this.couponList = this.data.filter(
                i => i.status === this.COUPON_INSTANCE_STATUS['USED']
                    || i.status === this.COUPON_INSTANCE_STATUS['EXPIRED']
                    || i.status === this.COUPON_INSTANCE_STATUS['REFUNDED']
                    || i.status === this.COUPON_INSTANCE_STATUS['DISCARDED']
            );
        } else {
            this.couponList = this.data.filter(
                i => i.status === this.COUPON_INSTANCE_STATUS['UNPAID']
                    || i.status === this.COUPON_INSTANCE_STATUS['READY_TO_USE']
            );
        }
    }
    public clickTab() {
        this.selectTab = findComponentsDownward(this, 'HybridTabs')[0].selected;
        this.updateCouponList();
    }
    public mounted() {
        this.updateCouponList();
    }
    public async getUserInfo(fjjUserId: number) {
        if (fjjUserId) {
            const userInfo = await this.userInfoDelegate.getUserInfo(fjjUserId);
            if (userInfo) {
                this.userInfo = userInfo;
            }
        }
    }
}
